import React from 'react';

import { Skeleton as StyledSkeleton } from './wrappers';

interface ISkeleton {
  height?: string;
  width?: string;
  mobileRatio?: string;
  desktopRatio?: string;
}

const Skeleton = ({ height = '150px', width = '100%', mobileRatio, desktopRatio }: ISkeleton) => {
  const styleObj = {
    width,
    height: !mobileRatio && !desktopRatio ? height : undefined,
  };

  let mobilePadding;
  let desktopPadding;

  if (mobileRatio) {
    const [width, height] = mobileRatio.split(':');
    mobilePadding = (parseInt(height) / parseInt(width)) * 100 + '%';
  }

  if (desktopRatio) {
    const [width, height] = desktopRatio.split(':');
    desktopPadding = (parseInt(height) / parseInt(width)) * 100 + '%';
  }

  return (
    <StyledSkeleton
      mobilePadding={mobilePadding}
      desktopPadding={desktopPadding}
      style={styleObj}
    />
  );
};

export default Skeleton;
